var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.615 1.60511C14.7614 1.68661 14.8763 1.81479 14.9413 1.96922C15.0064 2.12364 15.0179 2.2954 14.974 2.45711L12.982 9.76011H20.25C20.3961 9.76012 20.5391 9.80284 20.6613 9.88301C20.7835 9.96318 20.8796 10.0773 20.9378 10.2114C20.9961 10.3455 21.0138 10.4936 20.989 10.6376C20.9641 10.7817 20.8977 10.9153 20.798 11.0221L10.298 22.2721C10.1836 22.3949 10.0313 22.4758 9.86558 22.5019C9.69981 22.5279 9.53009 22.4976 9.38357 22.4159C9.23704 22.3341 9.12218 22.2055 9.05735 22.0507C8.99252 21.896 8.98146 21.7239 9.02595 21.5621L11.018 14.2601H3.74995C3.60379 14.2601 3.46082 14.2174 3.33861 14.1372C3.2164 14.057 3.12028 13.9429 3.06206 13.8088C3.00384 13.6748 2.98607 13.5266 3.01092 13.3826C3.03578 13.2385 3.10217 13.1049 3.20195 12.9981L13.702 1.74811C13.8163 1.62576 13.9683 1.5452 14.1338 1.51929C14.2993 1.49337 14.4687 1.52359 14.615 1.60511Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energyIcon.43135211383cc7719cad6b05225e91ae.svg";
export { ForwardRef as ReactComponent };